import PropTypes from 'prop-types'
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Button,
  ButtonGroup,
  Box,
} from '@chakra-ui/react'
import {TriangleDownIcon} from '@chakra-ui/icons'
import {useTranslation} from 'react-i18next'
import {openTab} from '../../../../../utils/browser'

const InvoiceActionCell = ({paymentUrl, informPaymentUrl}) => {
  const {t} = useTranslation('payerStatements')

  return (
    <Box textAlign="right">
      <Menu>
        <ButtonGroup size="md" isAttached variant="outline">
          <Button variant="secondary" onClick={openTab(paymentUrl)}>
            {t('invoices.table.button.payNow')}
          </Button>
          <MenuButton
            as={IconButton}
            variant="secondary"
            icon={<TriangleDownIcon width="10px" height="10px" />}
            onClick={(e) => e.stopPropagation()}
          />
        </ButtonGroup>
        <MenuList>
          <MenuItem
            as="a"
            href={informPaymentUrl}
            onClick={(e) => e.stopPropagation()}
          >
            {t('invoices.table.button.markAsPaid')}
          </MenuItem>
          <MenuItem>{t('invoices.table.button.viewDetails')}</MenuItem>
        </MenuList>
      </Menu>
    </Box>
  )
}

InvoiceActionCell.propTypes = {
  paymentUrl: PropTypes.string.isRequired,
  informPaymentUrl: PropTypes.string.isRequired,
}

export default InvoiceActionCell
